
import { RecentPayment, PaymentAction } from '@/types/RecentPayment'
import { defineComponent, PropType, ref } from 'vue'
import DropdownAction from '@/components/DropdownAction.vue'

export default defineComponent({
  name: 'RecentPayments',
  components: {
    DropdownAction,
  },
  props: {
    recentPayments: {
      type: Array as PropType<RecentPayment[]>,
      required: true,
    },
  },
  setup({ recentPayments }) {
    let payments = ref<RecentPayment[]>(recentPayments)
    const actionColor = (action: PaymentAction) => {
      return {
        payment: 'orange',
        refund: 'blue',
        credit: 'dark-purple',
      }[action]
    }
    const amountColor = (amount: string) => {
      return amount.includes('-') ? 'red' : 'green'
    }

    const deleteRecentPayment = (recentPayment: RecentPayment) => {
      const paymentIndex = payments.value.findIndex(
        (p: RecentPayment) => p.id === recentPayment.id
      )
      payments.value.splice(paymentIndex, 1)
    }

    return {
      payments,
      actionColor,
      amountColor,
      deleteRecentPayment,
    }
  },
})
